import { __decorate } from 'tslib';
import { Input, Component, ChangeDetectionStrategy, NgModule } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { PreventAutofocusModule } from '@egovsolutions/angular-prevent-autofocus';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/material/dialog';
import * as ɵngcc2 from '@angular/material/button';
import * as ɵngcc3 from '@angular/material/icon';
import * as ɵngcc4 from '@egovsolutions/angular-prevent-autofocus';
let DialogCloseButtonComponent = class DialogCloseButtonComponent {
    constructor(
    // Dependencies
    dialogRef) {
        this.dialogRef = dialogRef;
    }
    // Clicked
    clickHandler() {
        if (this.closeHandler)
            this.closeHandler(this.dialogReturns);
        else
            this.dialogRef.close(this.dialogReturns);
    }
};
DialogCloseButtonComponent.ɵfac = function DialogCloseButtonComponent_Factory(t) { return new (t || DialogCloseButtonComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.MatDialogRef)); };
DialogCloseButtonComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DialogCloseButtonComponent, selectors: [["egov-dialog-close-button"]], inputs: { dialogReturns: "dialogReturns", closeHandler: "closeHandler" }, decls: 3, vars: 0, consts: [["mat-button", "", "title", "Close dialog", "egovPreventAutofocus", "", 3, "click"]], template: function DialogCloseButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "button", 0);
        ɵngcc0.ɵɵlistener("click", function DialogCloseButtonComponent_Template_button_click_0_listener() { return ctx.clickHandler(); });
        ɵngcc0.ɵɵelementStart(1, "mat-icon");
        ɵngcc0.ɵɵtext(2, "close");
        ɵngcc0.ɵɵelementEnd()();
    } }, dependencies: [ɵngcc2.MatButton, ɵngcc3.MatIcon, ɵngcc4.ɵa], styles: ["[_nghost-%COMP%]{position:absolute;right:0;top:0;z-index:10}[_nghost-%COMP%]   .mat-button.mat-button.mat-button[_ngcontent-%COMP%]{min-width:0;margin:10px 10px 0 0;line-height:35px;padding:0;width:35px}[_nghost-%COMP%]   .mat-button.mat-button.mat-button[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:14px;color:#888}"], changeDetection: 0 });
DialogCloseButtonComponent.ctorParameters = () => [
    { type: MatDialogRef }
];
__decorate([
    Input()
], DialogCloseButtonComponent.prototype, "dialogReturns", void 0);
__decorate([
    Input()
], DialogCloseButtonComponent.prototype, "closeHandler", void 0);

let DialogCloseButtonModule = class DialogCloseButtonModule {
};
DialogCloseButtonModule.ɵfac = function DialogCloseButtonModule_Factory(t) { return new (t || DialogCloseButtonModule)(); };
DialogCloseButtonModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DialogCloseButtonModule });
DialogCloseButtonModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [MatButtonModule,
        MatIconModule,
        PreventAutofocusModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DialogCloseButtonComponent, [{
        type: Component,
        args: [{ selector: 'egov-dialog-close-button', template: "<button mat-button title=\"Close dialog\" egovPreventAutofocus (click)=\"clickHandler()\">\n    <mat-icon>close</mat-icon>\n</button>\n", changeDetection: ChangeDetectionStrategy.OnPush, styles: [":host{position:absolute;right:0;top:0;z-index:10}:host .mat-button.mat-button.mat-button{min-width:0;margin:10px 10px 0 0;line-height:35px;padding:0;width:35px}:host .mat-button.mat-button.mat-button mat-icon{font-size:14px;color:#888}"] }]
    }], function () { return [{ type: ɵngcc1.MatDialogRef }]; }, { dialogReturns: [{
            type: Input
        }], closeHandler: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DialogCloseButtonModule, [{
        type: NgModule,
        args: [{
                declarations: [DialogCloseButtonComponent],
                imports: [
                    MatButtonModule,
                    MatIconModule,
                    PreventAutofocusModule
                ],
                exports: [DialogCloseButtonComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DialogCloseButtonModule, { declarations: function () { return [DialogCloseButtonComponent]; }, imports: function () { return [MatButtonModule,
        MatIconModule,
        PreventAutofocusModule]; }, exports: function () { return [DialogCloseButtonComponent]; } }); })();

/*
 * Public API Surface of angular-dialog-close-button
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DialogCloseButtonModule, DialogCloseButtonComponent as ɵa };

